import type { StyleRule } from '@archipro-design/aria';

export const SaveToDesignBoard: StyleRule = () => ({
    cursor: 'grab',
});
